import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Spinner, Alert, Form, Button, Card, Container, Row, Col, Table, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUser } from 'react-icons/fa';
import apiService from "../../API/ApiService.js";

const OperatorManagement = () => {
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [userId, setUserId] = useState(null);
  const [newOperator, setNewOperator] = useState({
    uniqueIdentifier: '',
    name: '',
  });
  const [selectedOperator, setSelectedOperator] = useState(null);  // For updating an operator
  const [showModal, setShowModal] = useState(false);  // To toggle update modal visibility
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);  // For delete confirmation modal
  const [operatorToDelete, setOperatorToDelete] = useState(null);  // Store operator to delete

  // Récupérer l'ID de l'utilisateur depuis localStorage
  const username = localStorage.getItem('username');


  useEffect(() => {
    const fetchUserId = async () => {
      if (username) {
        try {
          console.log('(username+++',username)
          const response = await apiService.get('/getUserIdByEmail', {
            params: { email: username },
          });
          console.log('opp response',response)
          setUserId(response.data.userId);
        } catch (error) {
          console.error('Error fetching user ID:', error);
          setError('Failed to fetch user ID');
        } finally {
          setLoading(false);
        }
      } else {
        setError('Username not found in localStorage');
        setLoading(false);
      }
    };
  
    fetchUserId();
  }, [username]);
  

  useEffect(() => {
    if (userId) {
      const fetchOperators = async () => {
        try {
          const response = await apiService.get(`/getOperatorsByUserId/${userId}`);
          setOperators(response.data);
        } catch (err) {
          console.error('Error fetching operators:', err);
          setError('Unable to load operators.');
        } finally {
          setLoading(false);
        }
      };
  
      fetchOperators();
    }
  }, [userId]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewOperator((prevOperator) => ({
      ...prevOperator,
      [name]: value,
    }));
  };

  const handleAddOperator = async (e) => {
    e.preventDefault();
    if (!newOperator.uniqueIdentifier || !newOperator.name) {
      setError('Please provide both unique identifier and name.');
      return;
    }
  
    try {
      const response = await apiService.post('/operators', {
        ...newOperator,
        user_id: userId,
      });
      setOperators((prevOperators) => [...prevOperators, response.data]);
      setMessage('✅ Operator added successfully!');
      setNewOperator({ uniqueIdentifier: '', name: '' });
    } catch (err) {
      console.error('Error adding operator:', err);
      setMessage('');
      setError('❌ Failed to add operator.');
    }
  };
  

  const handleDeleteOperator = async () => {
    try {
      await apiService.delete(`/operators/${operatorToDelete.id}`);
      setOperators((prevOperators) => prevOperators.filter(op => op.id !== operatorToDelete.id));
      setMessage('✅ Operator deleted successfully!');
      setShowDeleteConfirmModal(false); // Close the confirmation modal
    } catch (err) {
      console.error('Error deleting operator:', err);
      setMessage('');
      setError('❌ Failed to delete operator.');
      setShowDeleteConfirmModal(false); // Close the modal even if failed
    }
  };
  
  const handleShowDeleteConfirm = (operator) => {
    setOperatorToDelete(operator); // Set the operator to be deleted
    setShowDeleteConfirmModal(true); // Show the confirmation modal
  };

  const handleCloseDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false); // Close the confirmation modal
    setOperatorToDelete(null); // Clear the operator to delete
  };

  const handleEditOperator = (operator) => {
    setSelectedOperator(operator); // Set the operator to be updated
    setShowModal(true);  // Show the modal to update the operator
  };

  const handleUpdateOperator = async () => {
    if (!selectedOperator.uniqueIdentifier || !selectedOperator.name) {
      setError('Please provide both unique identifier and name.');
      return;
    }

    try {
      await apiService.put(`/operators/${selectedOperator.id}`, {
        uniqueIdentifier: selectedOperator.uniqueIdentifier,
        name: selectedOperator.name,
      });
      setOperators((prevOperators) =>
        prevOperators.map((op) =>
          op.id === selectedOperator.id ? selectedOperator : op
        )
      );
      setMessage('✅ Operator updated successfully!');
      setShowModal(false);  // Close the modal
    } catch (err) {
      console.error('Error updating operator:', err);
      setMessage('');
      setError('❌ Failed to update operator.');
    }
    
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOperator(null);  // Reset selected operator
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <Container className="py-5">
      {message && <Alert variant="success">{message}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <h3 className="text-center mb-4 text-primary font-weight-bold display-4">
        <i className="bi bi-person-check"></i> Manage Operators
      </h3>

      <Form onSubmit={handleAddOperator} className="mb-4">
        <Form.Group className="mb-3">
          <Form.Label>🔒 Unique Identifier</Form.Label>
          <Form.Control
            type="text"
            name="uniqueIdentifier"
            value={newOperator.uniqueIdentifier}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>🧑‍💼 Operator Name</Form.Label>
          
          <Form.Control
            type="text"
            name="name"
            value={newOperator.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="d-block w-100">
          ➕ Add Operator
        </Button>
      </Form>

      <h4 className="mb-4">Operator List</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Unique Identifier</th>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {operators.map((operator) => (
            <tr key={operator.id}>
              <td>{operator.uniqueIdentifier}</td>
              <td>{operator.name}</td>
              <td>
                <Button
                  variant="warning"
                  onClick={() => handleEditOperator(operator)}
                  className="me-2"
                >
                  ✏️ Edit
                </Button>
                {/*<Button
                  variant="danger"
                  onClick={() => handleShowDeleteConfirm(operator)}  // Show confirmation modal
                >
                  🗑️ Delete
                </Button>*/}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal for updating an operator */}
      {selectedOperator && (
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Operator</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>🔑 Unique Identifier</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedOperator.uniqueIdentifier}
                  onChange={(e) =>
                    setSelectedOperator({
                      ...selectedOperator,
                      uniqueIdentifier: e.target.value,
                    })
                  }
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>👤 Operator Name</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedOperator.name}
                  onChange={(e) =>
                    setSelectedOperator({ ...selectedOperator, name: e.target.value })
                  }
                  required
                />
              </Form.Group>

              <Button variant="primary" onClick={handleUpdateOperator}>
                Update Operator
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      )}

      {/* Confirmation Modal for Deleting an Operator */}
      {operatorToDelete && (
        <Modal show={showDeleteConfirmModal} onHide={handleCloseDeleteConfirmModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete the operator {operatorToDelete.name}?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDeleteConfirmModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteOperator}>
              Delete Operator
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default OperatorManagement;
